import { render, staticRenderFns } from "./FormTableDialog.vue?vue&type=template&id=6b28561e&scoped=true&"
import script from "./FormTableDialog.vue?vue&type=script&lang=js&"
export * from "./FormTableDialog.vue?vue&type=script&lang=js&"
import style0 from "./FormTableDialog.vue?vue&type=style&index=0&id=6b28561e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b28561e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b28561e')) {
      api.createRecord('6b28561e', component.options)
    } else {
      api.reload('6b28561e', component.options)
    }
    module.hot.accept("./FormTableDialog.vue?vue&type=template&id=6b28561e&scoped=true&", function () {
      api.rerender('6b28561e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/FormTableDialog.vue"
export default component.exports